/* import __COLOCATED_TEMPLATE__ from './translations-table-row.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { TrackedArray } from 'tracked-built-ins';

export default class TranslationsTableDetailsRowComponent extends Component
{
	@service store;

	@action
	deleteTranslation()
	{
		const translation = this.args.translation;
		translation.deleteRecord();
		translation.save();
	}

	@action
	async showDetails()
	{
		const translation = this.args.translation;
		const chip = translation.chip;

		// Fetch passings for this chip
		const passings = await this.store.query('Passing',
		{
			filter:
			{
				chip: chip
			}
		});

		// Initialize passings as TrackedArray if not already set
		if (!translation.passings) {
			translation.set('passings', new TrackedArray([]));
		} else {
			// Clear existing passings
			translation.passings.splice(0, translation.passings.length);
		}

		// Fetch each passing individually and add to the tracked array
		const passingPromises = [];
		passings.forEach((passing) => {
			if(passing.chip === chip) {
				translation.passings.push(passing);
				passingPromises.push(this.store.findRecord('Passing', passing.id));
			}
		});

		// Wait for all individual passing fetches to complete
		await Promise.all(passingPromises);

		// Sort passings by time
		translation.passings.sort((a, b) => {
			const timeA = a.time ? new Date(a.time).getTime() : 0;
			const timeB = b.time ? new Date(b.time).getTime() : 0;
			return timeA - timeB;
		});

		// Toggle showDetails
		translation.set('showDetails', !translation.get('showDetails'));
	}
}